import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress, // kept for inline use
  Grid,
  Box,
  Button,
  Typography,
  TextField,
  MenuItem,
  InputAdornment,
  Paper,
  Chip,
  Divider,
  Tooltip,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Fade,
  alpha,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import IosShareIcon from "@mui/icons-material/IosShare";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import ActionButtons from "../../../Components/ui/ActionButtons";
import { NAVY, NAVY_DARK, GOLD, GOLD_SOFT, PAGE_BG, BORDER, TEXT_PRIMARY, TEXT_SECONDARY, SUCCESS, ERROR as RED } from "../../../theme/tokens";
import {
  useDeleteProductMutation,
  useGetProductQuery,
  useGetProductCategoryQuery,
  useGetProductBrandQuery,
  useGetProductTagQuery,
  useGetCategoryQuery,
  useGetAllMainCategoryQuery,
  useGetSubCategoryByArrayQuery,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IProductBrand,
  IProductCategory,
  IProductPopUP,
  IProductTag,
} from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import PageLoader from "../../../Components/Loader/PageLoader";
import { useNotifier } from "../../../Core/Notifier";
import { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";

import { useNavigate, Link } from "react-router-dom";
import Pagination from "../../../Components/Pagination";
import placeholderImage from '../../../Images/fav.webp';
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import InventoryIcon from "@mui/icons-material/Inventory";
import axios from "axios";

const Index = () => {
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;
  const getFormattedDate = (createDate: Dayjs | null): string => {
    return createDate ? createDate.format("YYYY-MM-DD") : "";
  };
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [selectedProductBrandId, setSelectedProductBrandId] =
    useState<string>("");
  const [selectedProductCategoryId, setSelectedProductCategoryId] =
    useState<string>("");
  const [selectedProductTagIds, setSelectedProductTagIds] = useState<string[]>(
    []
  );
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [selectedProductViewOnline, setSelectedProductViewOnline] =
    useState<string>("");
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const startDateAsDate = startDate?.toDate() || null;
  const endDateAsDate = endDate?.toDate() || null;
  const [createDate, setCreateDate] = useState<Dayjs | null>(null);
  const [isPaperVisible, setIsPaperVisible] = useState(false);
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [editingCell, setEditingCell] = useState<string | null>(null);
  const [editValue, setEditValue] = useState<string>("");

  const { data: categoryData } = useGetAllMainCategoryQuery({
    departmentId: "",
    coursingId: "",
    roleId: null,
    taxeId: "",
    createdDateStart: null,
    createdDateEnd: null,
    searchText: "",
    numberOfLength: 0,
    isActive: true,
    categoryIsLooping: null,
    createdDate: null,
  });

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
    useState<number | null>(null);

  const { data: subCategoryData, refetch: refetchSubCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
    });

  const { data: subCategory2Data, refetch: refetchS2bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
        : [],
    });

  const { data: subCategory3Data, refetch: refetchS3bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [
            Number(selectedCategoryId),
            Number(selectedSubCategoryId),
            Number(selectedSubToSubCategoryId),
          ]
        : [],
    });
  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const subCategoryList = useMemo(() => {
    return subCategoryData?.data as ICategory[];
  }, [subCategoryData?.data]);

  const subToSubCategoryList = useMemo(() => {
    return subCategory2Data?.data as ICategory[];
  }, [subCategory2Data?.data]);

  const subToSubToSubCategoryList = useMemo(() => {
    return subCategory3Data?.data as ICategory[];
  }, [subCategory3Data?.data]);

  const productCategoryId = selectedSubToSubToSubCategoryId
    ? Number(selectedSubToSubToSubCategoryId)
    : selectedSubToSubCategoryId
    ? Number(selectedSubToSubCategoryId)
    : selectedSubCategoryId
    ? Number(selectedSubCategoryId)
    : selectedCategoryId
    ? Number(selectedCategoryId)
    : String("");

 


  const { data, isLoading, isError, refetch } = useGetProductQuery({
    productBrandId: selectedProductBrandId,
    productCategoryId: String(productCategoryId),
    productTagIds: selectedProductTagIds,
    productViewOnline: selectedProductViewOnline,
    createdDateStart: startDateAsDate as Date,
    createdDateEnd: endDateAsDate as Date,
    searchText: currentSearchQuery,
    createdDate: getFormattedDate(createDate),
    id: null,
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [selectedProduct, setSelectedProduct] = useState<IProductPopUP | null>(
    null
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
  const [productToDelete, setProductToDelete] = useState<IProductPopUP | null>(
    null
  );

  // ── Column sort ──
  type SortKey = "name" | "barcode" | "category" | "subcategory" | "cost" | "instore" | "wholesale" | "online" | "stock";
  const [sortKey, setSortKey] = useState<SortKey>("name");
  const [sortDir, setSortDir] = useState<"asc" | "desc">("asc");
  const toggleSort = (key: SortKey) => {
    if (sortKey === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else { setSortKey(key); setSortDir("asc"); }
  };

  // ── Bulk selection ──
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());
  const [bulkDeleteOpen, setBulkDeleteOpen] = useState(false);
  const [bulkDeleting, setBulkDeleting] = useState(false);
  const [moveCategoryOpen, setMoveCategoryOpen] = useState(false);
  const [moveCategoryTarget, setMoveCategoryTarget] = useState<number | "">("");
  const [moveCategoryBusy, setMoveCategoryBusy] = useState(false);


  const { data: productBrandData, isLoading: productBrandLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });
  const { data: coursingData, isLoading: coursingLoading } =
    useGetCategoryQuery();
  const { data: taxData, isLoading: taxLoading } = useGetProductTagQuery({
    searchText: "",
    isActive: true,
  });
  const { data: productCategoryData, isLoading: productCategoryLoading } =
    useGetProductCategoryQuery({
      searchText: "",
      isActive: true,
    });
  const { data: productTagData, isLoading: ProductTagLoading } =
    useGetProductTagQuery({
      searchText: "",
      isActive: true,
    });

  const productBrandList = useMemo(() => {
    return productBrandData?.data as IProductBrand[];
  }, [productBrandData?.data]);

  const coursingList = useMemo(() => {
    return coursingData?.data as ICategory[];
  }, [coursingData?.data]);

  const taxList = useMemo(() => {
    return taxData?.data as IProductTag[];
  }, [taxData?.data]);

  const productList = useMemo(() => {
    return productCategoryData?.data as IProductCategory[];
  }, [productCategoryData?.data]);

  const productTagList = useMemo(() => {
    return productTagData?.data as IProductTag[];
  }, [productTagData?.data]);

  const productBrandMap = useMemo(() => {
    const map = new Map();
    productBrandList?.forEach((brand) => {
      map.set(brand.id, brand.productBrandName);
    });
    return map;
  }, [productBrandList]);

  const coursingMap = useMemo(() => {
    const map = new Map();
    coursingList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [coursingList]);

  const parentCategoryMap = useMemo(() => {
    const map = new Map<number, string>();
    coursingList?.forEach((category) => {
      if (category.parent_ids && category.parent_ids.length > 0) {
        const parentId = category.parent_ids[0];
        const parentCat = coursingList.find((c) => c.id === parentId);
        if (parentCat) {
          map.set(category.id, parentCat.categoryName);
        }
      }
    });
    return map;
  }, [coursingList]);

  const taxMap = useMemo(() => {
    const map = new Map();
    taxList?.forEach((tag) => {
      map.set(tag.id, tag.tagName);
    });
    return map;
  }, [taxList]);

 

  const handleMainCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const raw = event.target.value;
    const categoryId = raw === "" || raw === "all" ? null : (raw as number);
    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
  };

  const handleSubCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const subCategoryId = event.target.value as number;
    setSelectedSubCategoryId(subCategoryId);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = subCategoryList.find(
      (category) => category.id == subCategoryId
    );
  };

  const handleSubToSubCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedSubToSubCategoryId = event.target.value as number;
    setSelectedSubToSubCategoryId(selectedSubToSubCategoryId);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = subToSubCategoryList.find(
      (category) => category.id == selectedSubToSubCategoryId
    );
  };

  const handleSubToSubToSubCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedSubToSubToSubCategoryId = event.target.value as number;
    setSelectedSubToSubToSubCategoryId(selectedSubToSubToSubCategoryId);

    const selectedCategory = subToSubToSubCategoryList.find(
      (category) => category.id == selectedSubToSubToSubCategoryId
    );
  };

  useEffect(() => {
    setCurrentSearchQuery(debouncedSearchQuery);
    refetch();
  }, [debouncedSearchQuery]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (product: IProductPopUP) => {
    setSelectedProduct(product);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (product: IProductPopUP) => {
    setProductToDelete(product);
    setOpenDeleteProduct(true);
  };

  const handleCloseDeletePopup = () => {
    setProductToDelete(null);
    setOpenDeleteProduct(false);
  };

  const handleProductBrandChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductBrandId(selectedValues);
  };

  const handleProductViewOnline = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductViewOnline(selectedValues);
  };

  const handleProductCategory = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductCategoryId(selectedValues);
  };

  const handleStartDateChange = (newValue: Dayjs | null) => {
    setStartDate(newValue);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    setEndDate(newValue);
  };

  const handleCreateDateChange = (newValue: Dayjs | null) => {
    setCreateDate(newValue);
  };

  const handleProductTag = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;
    setSelectedProductTagIds(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const [deleteCategory] = useDeleteProductMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteProduct(false);
      } else {
        showErrorMessage("Failed to delete the product");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the product");
    }
  };

  const handleToggle = () => {
    setIsPaperVisible(!isPaperVisible);
  };

const [isImporting, setIsImporting] = useState(false);

const downloadTemplate = async () => {
  try {
    const response = await fetch(`${API_URL}/products/template`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    });
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "product_template.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error(err);
    showErrorMessage("Failed to download template");
  }
};

const handleImport = async (e: React.ChangeEvent<HTMLInputElement>) => {
  if (!e.target.files?.length) return;
  const file = e.target.files[0];
  const formData = new FormData();
  formData.append("file", file);

  try {
    setIsImporting(true);
    const res = await fetch(`${API_URL}/products/import`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
      body: formData,
    });

    const data = await res.json();

    if (!res.ok) {
      showErrorMessage(data.message || "Import failed");
      return;
    }

    if (data.duplicates && data.duplicates.length > 0) {
      const duplicateList = data.duplicates
        .map((d: { row: number; productName: string; reason?: string }) =>
          d.reason ? `Row ${d.row}: ${d.reason}` : `Row ${d.row}: ${d.productName}`
        )
        .join("\n");
      showErrorMessage(
        `Imported ${data.inserted} products.\n\nSkipped rows:\n${duplicateList}`
      );
    } else {
      showMessage(`${data.inserted} products imported successfully`);
    }

    refetch();
  } catch (err) {
    console.error(err);
    showErrorMessage("Import error. Please try again.");
  } finally {
    setIsImporting(false);
    e.target.value = "";
  }
};

const handleDoubleClick = (
  rowId: string | number,
  field: string,
  value: string | number | null | undefined
) => {
  setEditingCell(`${rowId}-${field}`);
  setEditValue(value ? String(value) : "");
};

const handleSaveInline = async (row: IProductPopUP, field: string) => {
  const val = editValue.trim();
  if (!val && field !== "stock") { setEditingCell(null); return; }
  const numVal = Number(val) || 0;
  const headers = { Authorization: `Bearer ${localStorage.getItem("token") || ""}` };

  try {
    if (field === "stock") {
      await axios.put(`${API_URL}/warehouse/product/${row.id}/settings`, {
        current_stock: numVal,
        track_inventory: true,
      }, { headers });
      showMessage("Stock updated");
    } else if (field === "productPrice") {
      // Validate: cost cannot exceed instore or wholesale
      const instore = Number(row.salePrice) || 0;
      const wholesale = Number(row.wholesaleprice) || 0;
      if (instore > 0 && numVal > instore) {
        showErrorMessage(`Cost ($${numVal.toFixed(2)}) cannot exceed instore price ($${instore.toFixed(2)})`);
        setEditingCell(null); return;
      }
      if (wholesale > 0 && numVal > wholesale) {
        showErrorMessage(`Cost ($${numVal.toFixed(2)}) cannot exceed wholesale price ($${wholesale.toFixed(2)})`);
        setEditingCell(null); return;
      }
      const res = await axios.post(`${API_URL}/save-manual-price`, {
        productId: row.id,
        cost_price: numVal,
      }, { headers });
      if (res.data?.status === false) { showErrorMessage(res.data.message); setEditingCell(null); return; }
      showMessage("Cost updated");
    } else if (field === "salePrice") {
      // Validate: instore cannot be less than cost
      const cost = Number(row.productPrice) || 0;
      if (cost > 0 && numVal > 0 && numVal < cost) {
        showErrorMessage(`Instore price ($${numVal.toFixed(2)}) cannot be less than cost ($${cost.toFixed(2)})`);
        setEditingCell(null); return;
      }
      const res = await axios.post(`${API_URL}/save-manual-price`, {
        productId: row.id,
        reg_price: numVal,
      }, { headers });
      if (res.data?.status === false) { showErrorMessage(res.data.message); setEditingCell(null); return; }
      showMessage("Instore price updated");
    } else if (field === "wholesaleprice") {
      // Validate: wholesale cannot be less than cost
      const cost = Number(row.productPrice) || 0;
      if (cost > 0 && numVal > 0 && numVal < cost) {
        showErrorMessage(`Wholesale price ($${numVal.toFixed(2)}) cannot be less than cost ($${cost.toFixed(2)})`);
        setEditingCell(null); return;
      }
      const res = await axios.post(`${API_URL}/save-manual-price`, {
        productId: row.id,
        wholesale_price: numVal,
      }, { headers });
      if (res.data?.status === false) { showErrorMessage(res.data.message); setEditingCell(null); return; }
      showMessage("Wholesale price updated");
    }
    refetch();
    setEditingCell(null);
  } catch (err) {
    console.error(err);
    showErrorMessage("Error updating");
    setEditingCell(null);
  }
};

  const selectSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2, fontSize: 13, bgcolor: "#fff",
      "& fieldset": { borderColor: BORDER },
      "&:hover fieldset": { borderColor: alpha(GOLD, 0.6) },
      "&.Mui-focused fieldset": { borderColor: GOLD, borderWidth: 1.5 },
    },
  };

  if (
    isLoading ||
    productBrandLoading ||
    coursingLoading ||
    taxLoading ||
    productCategoryLoading ||
    ProductTagLoading
  ) {
    return <PageLoader height="40vh" />;
  }

  const coursings: IProductPopUP[] = (() => {
    const list = Array.isArray(data?.data) ? (data?.data as IProductPopUP[]) : [];
    const sorted = list.slice().sort((a: any, b: any) => {
      const get = (row: any): string | number => {
        switch (sortKey) {
          case "name":        return (row.productName || "").toString();
          case "barcode":     return (row.productBarcode || row.productManualBarcode || "").toString();
          case "category":    return (parentCategoryMap.get(row.productCategoryId) || coursingMap.get(row.productCategoryId) || "").toString();
          case "subcategory": return (parentCategoryMap.has(row.productCategoryId) ? coursingMap.get(row.productCategoryId) || "" : "").toString();
          case "cost":        return Number(row.productPrice) || 0;
          case "instore":     return Number(row.salePrice) || 0;
          case "wholesale":   return Number(row.wholesaleprice) || 0;
          case "online":      return row.productViewOnline ? 1 : 0;
          case "stock":       return Number(row.available_stock) || 0;
          default:            return "";
        }
      };
      const va = get(a), vb = get(b);
      let cmp: number;
      if (typeof va === "number" && typeof vb === "number") cmp = va - vb;
      else cmp = String(va).localeCompare(String(vb), undefined, { sensitivity: "base", numeric: true });
      return sortDir === "asc" ? cmp : -cmp;
    });
    return sorted;
  })();

  // ── Bulk selection logic ──
  const visibleRows = coursings.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const visibleIds = visibleRows.map((r) => Number(r.id));
  const allVisibleSelected = visibleIds.length > 0 && visibleIds.every((id) => selectedIds.has(id));
  const someVisibleSelected = visibleIds.some((id) => selectedIds.has(id)) && !allVisibleSelected;

  const toggleRow = (id: number) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleAllVisible = () => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (allVisibleSelected) {
        visibleIds.forEach((id) => next.delete(id));
      } else {
        visibleIds.forEach((id) => next.add(id));
      }
      return next;
    });
  };

  const clearSelection = () => setSelectedIds(new Set());

  const handleBulkDelete = async () => {
    if (selectedIds.size === 0) return;
    setBulkDeleting(true);
    try {
      const res = await fetch(`${API_URL}/products/bulk-delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        },
        body: JSON.stringify({ ids: Array.from(selectedIds) }),
      });
      const json = await res.json();
      if (!res.ok || json.status === false) {
        showErrorMessage(json.message || "Failed to delete selected products");
      } else {
        showMessage(json.message || `${selectedIds.size} products deleted`);
        clearSelection();
        setBulkDeleteOpen(false);
        refetch();
      }
    } catch (err) {
      console.error(err);
      showErrorMessage("Failed to delete selected products");
    } finally {
      setBulkDeleting(false);
    }
  };

  const handleBulkExportCsv = () => {
    if (selectedIds.size === 0) return;
    const rows = coursings.filter((r) => selectedIds.has(Number(r.id)));
    const headers = [
      "ID", "Product Name", "Barcode", "Manual Barcode",
      "Category", "Sub Category", "Cost", "Instore Price",
      "Wholesale Price", "Online", "Stock",
    ];
    const escape = (v: any) => {
      const s = v == null ? "" : String(v);
      return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };
    const lines = [headers.join(",")];
    rows.forEach((r: any) => {
      lines.push([
        r.id,
        r.productName,
        r.productBarcode,
        r.productManualBarcode,
        parentCategoryMap.get(r.productCategoryId) || coursingMap.get(r.productCategoryId) || "",
        parentCategoryMap.has(r.productCategoryId) ? coursingMap.get(r.productCategoryId) || "" : "",
        r.productPrice ?? "",
        r.salePrice ?? "",
        r.wholesaleprice ?? "",
        r.productViewOnline ? "Yes" : "No",
        r.available_stock ?? 0,
      ].map(escape).join(","));
    });
    const csv = "﻿" + lines.join("\n"); // BOM for Excel compatibility
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `products_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    showMessage(`Exported ${rows.length} products`);
  };

  const handleBulkMoveCategory = async () => {
    if (selectedIds.size === 0 || !moveCategoryTarget) return;
    setMoveCategoryBusy(true);
    try {
      const res = await fetch(`${API_URL}/products/bulk-update-category`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        },
        body: JSON.stringify({
          ids: Array.from(selectedIds),
          productCategoryId: moveCategoryTarget,
        }),
      });
      const json = await res.json();
      if (!res.ok || json.status === false) {
        showErrorMessage(json.message || "Failed to move products");
      } else {
        showMessage(json.message || `${selectedIds.size} products moved`);
        clearSelection();
        setMoveCategoryOpen(false);
        setMoveCategoryTarget("");
        refetch();
      }
    } catch (err) {
      console.error(err);
      showErrorMessage("Failed to move products");
    } finally {
      setMoveCategoryBusy(false);
    }
  };

  const resetFields = () => {
    setSelectedProductBrandId("");
    setSelectedProductCategoryId("");
    setSelectedProductViewOnline("");
    setSelectedProductTagIds([]);
    setStartDate(null);
    setEndDate(null);
    setCreateDate(null);
    // setSelectedCategoryId(null);
    // setSelectedSubCategoryId(null);
    // setSelectedSubToSubCategoryId(null);
    // setSelectedSubToSubToSubCategoryId(null);
  };

  const handleAddProductClick = () => {
    navigate("/product/create");
  };

  return (
    <Box sx={{ bgcolor: PAGE_BG, minHeight: "100vh" }}>
      {/* ── Top Bar ── */}
      <Box sx={{ bgcolor: "#fff", borderBottom: `1px solid ${BORDER}`, px: 3, py: 2.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2.5, mx: "auto" }}>
          <Box sx={{
            width: 44, height: 44, borderRadius: 3, display: "flex", alignItems: "center", justifyContent: "center",
            background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_DARK} 100%)`,
            boxShadow: `0 6px 18px ${alpha(NAVY, 0.35)}`,
            border: `1px solid ${alpha(GOLD, 0.35)}`,
          }}>
            <InventoryIcon sx={{ fontSize: 22, color: GOLD }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography fontSize={22} fontWeight={800} color={NAVY} letterSpacing="-0.02em">Products</Typography>
            <Typography fontSize={12} color={TEXT_SECONDARY} fontWeight={400}>{coursings.length} items in catalog</Typography>
          </Box>
          <TextField
            size="small"
            placeholder="Search by name or barcode..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 18, color: TEXT_SECONDARY }} />
                </InputAdornment>
              ),
            }}
            sx={{
              width: 300,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2, fontSize: 13, bgcolor: "#fff",
                "& fieldset": { borderColor: BORDER },
                "&:hover fieldset": { borderColor: alpha(GOLD, 0.6) },
                "&.Mui-focused fieldset": { borderColor: GOLD, borderWidth: 1.5 },
              },
            }}
          />
          <Button variant="outlined" size="small" onClick={handleToggle}
            startIcon={<FilterListIcon sx={{ fontSize: 15 }} />}
            sx={{
              borderRadius: 1.5, textTransform: "none", fontSize: 12, fontWeight: 500,
              borderColor: isPaperVisible ? GOLD : BORDER,
              color: isPaperVisible ? NAVY : TEXT_PRIMARY,
              bgcolor: isPaperVisible ? alpha(GOLD, 0.08) : "transparent",
              "&:hover": { borderColor: GOLD, bgcolor: alpha(GOLD, 0.08), color: NAVY },
            }}>
            Filters
          </Button>
          <Divider orientation="vertical" flexItem sx={{ borderColor: BORDER }} />
          <Button variant="outlined" size="small" onClick={downloadTemplate}
            startIcon={<FileDownloadIcon sx={{ fontSize: 15 }} />}
            sx={{
              borderRadius: 1.5, textTransform: "none", fontSize: 12, fontWeight: 500,
              borderColor: BORDER, color: TEXT_PRIMARY,
              "&:hover": { borderColor: GOLD, bgcolor: alpha(GOLD, 0.08), color: NAVY },
            }}>
            Template
          </Button>
          <Button variant="outlined" size="small" component="label" disabled={isImporting}
            startIcon={<FileUploadIcon sx={{ fontSize: 15 }} />}
            sx={{
              borderRadius: 1.5, textTransform: "none", fontSize: 12, fontWeight: 500,
              borderColor: BORDER, color: TEXT_PRIMARY,
              "&:hover": { borderColor: GOLD, bgcolor: alpha(GOLD, 0.08), color: NAVY },
            }}>
            {isImporting ? "Importing..." : "Import"}
            <input type="file" hidden accept=".xlsx,.xls,.csv" onChange={handleImport} />
          </Button>
          <Button variant="contained" color="secondary" disableElevation size="small" onClick={handleAddProductClick}
            startIcon={<AddIcon sx={{ fontSize: 16 }} />}
            sx={{
              borderRadius: 2.5, textTransform: "none", fontSize: 13, fontWeight: 700, px: 3,
              color: NAVY_DARK,
              background: `linear-gradient(135deg, ${GOLD} 0%, ${GOLD_SOFT} 100%)`,
              boxShadow: `0 4px 14px ${alpha(GOLD, 0.45)}`,
              "&:hover": {
                background: `linear-gradient(135deg, #C8A030 0%, ${GOLD} 100%)`,
                boxShadow: `0 6px 20px ${alpha(GOLD, 0.55)}`,
                transform: "translateY(-1px)",
              },
            }}>
            Add Product
          </Button>
        </Box>
      </Box>

      {/* ── Content ── */}
      <Box sx={{ mx: "auto", p: 3 }}>

        {/* ── Category Filters ── */}
        <Paper elevation={0} sx={{ p: 2.5, mb: 2, borderRadius: 2.5, border: "1px solid #E5E7EB" }}>
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <Typography sx={{ fontSize: 11, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>Main Category</Typography>
              <TextField select fullWidth size="small" value={selectedCategoryId ?? ""} onChange={handleMainCategoryChange} sx={selectSx}>
                <MenuItem value="" sx={{ fontSize: 13, fontWeight: 600, color: NAVY }}>All Products</MenuItem>
                <Divider sx={{ my: 0.5 }} />
                {categoryList && categoryList.map((category) => (
                  <MenuItem key={category.id} value={category.id} sx={{ fontSize: 13 }}>{category.categoryName}</MenuItem>
                ))}
              </TextField>
            </Grid>
            {selectedCategoryId && subCategoryList?.length > 0 && (
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>Sub Category</Typography>
                <TextField select fullWidth size="small" value={selectedSubCategoryId ?? ""} onChange={handleSubCategoryChange} sx={selectSx}>
                  <MenuItem value="" disabled sx={{ color: "#94a3b8", fontSize: 13 }}>Select an option</MenuItem>
                  {subCategoryList.map((sc) => (
                    <MenuItem key={sc.id} value={sc.id} sx={{ fontSize: 13 }}>{sc.categoryName}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            {selectedCategoryId && selectedSubCategoryId && subToSubCategoryList?.length > 0 && (
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>Sub-to-Sub Category</Typography>
                <TextField select fullWidth size="small" value={selectedSubToSubCategoryId ?? ""} onChange={handleSubToSubCategoryChange} sx={selectSx}>
                  <MenuItem value="" disabled sx={{ color: "#94a3b8", fontSize: 13 }}>Select an option</MenuItem>
                  {subToSubCategoryList.map((s) => (
                    <MenuItem key={s.id} value={s.id} sx={{ fontSize: 13 }}>{s.categoryName}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            {selectedCategoryId && selectedSubCategoryId && selectedSubToSubCategoryId && subToSubToSubCategoryList?.length > 0 && (
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>Sub-to-Sub-to-Sub</Typography>
                <TextField select fullWidth size="small" value={selectedSubToSubToSubCategoryId ?? ""} onChange={handleSubToSubToSubCategoryChange} sx={selectSx}>
                  <MenuItem value="" disabled sx={{ color: "#94a3b8", fontSize: 13 }}>Select an option</MenuItem>
                  {subToSubToSubCategoryList.map((s) => (
                    <MenuItem key={s.id} value={s.id} sx={{ fontSize: 13 }}>{s.categoryName}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
          </Grid>
        </Paper>

        {/* ── Advanced Filters (togglable) ── */}
        {isPaperVisible && (
          <Paper elevation={0} sx={{ p: 2.5, mb: 2, borderRadius: 2.5, border: `1px solid ${BORDER}` }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
              <FilterListIcon sx={{ fontSize: 18, color: GOLD }} />
              <Typography fontSize={13} fontWeight={700} color={NAVY}>Advanced Filters</Typography>
            </Box>
            <Grid container spacing={2} alignItems="flex-end">
              <Grid item xs={12} sm={6} md={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>Tag</Typography>
                <TextField select fullWidth size="small" SelectProps={{ multiple: true, native: false }} value={selectedProductTagIds || ""} onChange={handleProductTag} sx={selectSx}>
                  {productTagList && productTagList.length > 0 ? (
                    productTagList.map((pt: IProductTag) => (
                      <MenuItem key={pt.id} value={pt.id} sx={{ fontSize: 13 }}>{pt.tagName}</MenuItem>
                    ))
                  ) : (
                    <MenuItem value="" sx={{ color: "#94a3b8", fontSize: 13 }}>No tags</MenuItem>
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>Brand</Typography>
                <TextField select fullWidth size="small" value={selectedProductBrandId || ""} onChange={handleProductBrandChange} sx={selectSx}>
                  <MenuItem value="" sx={{ color: "#94a3b8", fontSize: 13 }}>All Brands</MenuItem>
                  {productBrandList.map((pb) => (
                    <MenuItem key={pb.id} value={pb.id} sx={{ fontSize: 13 }}>{pb.productBrandName}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>View Online</Typography>
                <TextField select fullWidth size="small" value={selectedProductViewOnline || ""} onChange={handleProductViewOnline} sx={selectSx}>
                  <MenuItem value="" sx={{ color: "#94a3b8", fontSize: 13 }}>All</MenuItem>
                  <MenuItem value="1" sx={{ fontSize: 13 }}>Yes</MenuItem>
                  <MenuItem value="0" sx={{ fontSize: 13 }}>No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>Create Date</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker onChange={handleCreateDateChange} value={createDate}
                    slotProps={{ textField: { size: "small", fullWidth: true, sx: selectSx } }} />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>Start Date</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker onChange={handleStartDateChange} value={startDate}
                    slotProps={{ textField: { size: "small", fullWidth: true, sx: selectSx } }} />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>End Date</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker onChange={handleEndDateChange} value={endDate}
                    slotProps={{ textField: { size: "small", fullWidth: true, sx: selectSx } }} />
                </LocalizationProvider>
              </Grid>
            </Grid>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button variant="outlined" size="small" startIcon={<RestartAltIcon sx={{ fontSize: 16 }} />} onClick={resetFields}
                sx={{
                  borderRadius: 2, textTransform: "none", fontSize: 12, fontWeight: 600,
                  borderColor: BORDER, color: TEXT_SECONDARY,
                  "&:hover": { borderColor: GOLD, color: NAVY, bgcolor: alpha(GOLD, 0.08) },
                }}>
                Reset Filters
              </Button>
            </Box>
          </Paper>
        )}

        {/* ── Bulk Action Toolbar ── */}
        <Fade in={selectedIds.size > 0} unmountOnExit>
          <Paper
            elevation={0}
            sx={{
              position: "sticky",
              top: 8,
              zIndex: 5,
              mb: 2,
              px: 2.5,
              py: 1.5,
              borderRadius: 2.5,
              border: `1px solid ${alpha(GOLD, 0.5)}`,
              bgcolor: "#fffdf6",
              boxShadow: "0 8px 24px rgba(15,23,42,0.10)",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              flexWrap: "wrap",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{
                width: 28, height: 28, borderRadius: "50%",
                bgcolor: GOLD, color: NAVY_DARK,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 12, fontWeight: 800,
              }}>
                {selectedIds.size}
              </Box>
              <Typography fontSize={13} fontWeight={700} color={NAVY}>
                Product{selectedIds.size === 1 ? "" : "s"} Selected
              </Typography>
            </Box>
            <Box sx={{ flex: 1 }} />
            <Button
              size="small"
              variant="contained"
              disableElevation
              startIcon={<DeleteOutlineIcon sx={{ fontSize: 16 }} />}
              onClick={() => setBulkDeleteOpen(true)}
              sx={{
                borderRadius: 2, textTransform: "none", fontSize: 12, fontWeight: 700,
                color: NAVY_DARK,
                background: `linear-gradient(135deg, ${GOLD} 0%, ${GOLD_SOFT} 100%)`,
                "&:hover": { background: `linear-gradient(135deg, #C8A030 0%, ${GOLD} 100%)` },
              }}
            >
              Delete Selected
            </Button>
            <Button
              size="small"
              variant="contained"
              disableElevation
              startIcon={<IosShareIcon sx={{ fontSize: 16 }} />}
              onClick={handleBulkExportCsv}
              sx={{
                borderRadius: 2, textTransform: "none", fontSize: 12, fontWeight: 700,
                bgcolor: NAVY, color: "#fff",
                "&:hover": { bgcolor: NAVY_DARK },
              }}
            >
              Export Selected
            </Button>
            <Button
              size="small"
              variant="outlined"
              startIcon={<DriveFileMoveIcon sx={{ fontSize: 16 }} />}
              onClick={() => setMoveCategoryOpen(true)}
              sx={{
                borderRadius: 2, textTransform: "none", fontSize: 12, fontWeight: 600,
                borderColor: alpha(NAVY, 0.3), color: NAVY,
                "&:hover": { borderColor: NAVY, bgcolor: alpha(NAVY, 0.06) },
              }}
            >
              Move Category
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={clearSelection}
              sx={{
                borderRadius: 2, textTransform: "none", fontSize: 12, fontWeight: 600,
                borderColor: BORDER, color: TEXT_SECONDARY,
                "&:hover": { borderColor: TEXT_PRIMARY, bgcolor: "#f8fafc" },
              }}
            >
              Clear Selection
            </Button>
          </Paper>
        </Fade>

        {/* ── Table ── */}
        <Paper elevation={0} sx={{ borderRadius: "12px", border: `1px solid ${BORDER}`, overflow: "hidden", boxShadow: "0 4px 12px rgba(11,30,45,0.06)" }}>
          <TableContainer sx={{ scrollBehavior: "smooth" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    padding="checkbox"
                    sx={{
                      borderBottom: `1px solid ${BORDER}`,
                      background: `linear-gradient(180deg, ${alpha(NAVY, 0.06)} 0%, #f8fafc 100%)`,
                      px: 1.5,
                    }}
                  >
                    <Checkbox
                      size="small"
                      checked={allVisibleSelected}
                      indeterminate={someVisibleSelected}
                      onChange={toggleAllVisible}
                      sx={{
                        color: alpha(NAVY, 0.4),
                        "&.Mui-checked, &.MuiCheckbox-indeterminate": { color: GOLD },
                      }}
                    />
                  </TableCell>
                  {([
                    { label: "#",                key: null },
                    { label: "Product",          key: "name" as SortKey },
                    { label: "Barcode",          key: "barcode" as SortKey },
                    { label: "Category",         key: "category" as SortKey },
                    { label: "Sub Category",     key: "subcategory" as SortKey },
                    { label: "Cost",             key: "cost" as SortKey },
                    { label: "Instore Price",    key: "instore" as SortKey },
                    { label: "Wholesale Price",  key: "wholesale" as SortKey },
                    { label: "Online",           key: "online" as SortKey },
                    { label: "Stock",            key: "stock" as SortKey },
                    { label: "Actions",          key: null },
                  ]).map((col) => {
                    const active = col.key && sortKey === col.key;
                    return (
                    <TableCell key={col.label}
                      onClick={col.key ? () => toggleSort(col.key as SortKey) : undefined}
                      sx={{
                        fontSize: 11, fontWeight: 800, color: active ? GOLD : NAVY,
                        textTransform: "uppercase", letterSpacing: "0.06em",
                        borderBottom: `1px solid ${BORDER}`, py: 1.5, px: 2, whiteSpace: "nowrap",
                        background: `linear-gradient(180deg, ${alpha(NAVY, 0.06)} 0%, #f8fafc 100%)`,
                        cursor: col.key ? "pointer" : "default",
                        userSelect: "none",
                        transition: "color 0.15s",
                        "&:hover": col.key ? { color: GOLD } : {},
                        ...(col.label === "Actions" ? { minWidth: 200 } : {}),
                      }}>
                      <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                        {col.label}
                        {active && (sortDir === "asc"
                          ? <span style={{ fontSize: 10, lineHeight: 1 }}>▲</span>
                          : <span style={{ fontSize: 10, lineHeight: 1 }}>▼</span>)}
                      </Box>
                    </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {isError || coursings.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={12} align="center" sx={{ py: 8, color: "#94a3b8", fontSize: 13 }}>
                      {isError ? "Error fetching data" : "No products found"}
                    </TableCell>
                  </TableRow>
                ) : (
                  coursings
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row: IProductPopUP, index) => {
                      const rowId = Number(row.id);
                      const isSelected = selectedIds.has(rowId);
                      return (
                      <TableRow
                        key={row.id}
                        selected={isSelected}
                        sx={{
                          transition: "background 0.15s",
                          bgcolor: isSelected ? alpha(GOLD, 0.10) : "transparent",
                          "&.Mui-selected": { bgcolor: alpha(GOLD, 0.10) },
                          "&.Mui-selected:hover": { bgcolor: alpha(GOLD, 0.16) },
                          "&:hover": { bgcolor: isSelected ? alpha(GOLD, 0.16) : "#F9FAFB" },
                        }}
                      >
                        {/* Select */}
                        <TableCell padding="checkbox" sx={{ borderBottom: "1px solid #F3F4F6", px: 1.5 }}>
                          <Checkbox
                            size="small"
                            checked={isSelected}
                            onChange={() => toggleRow(rowId)}
                            sx={{
                              color: alpha(NAVY, 0.4),
                              "&.Mui-checked": { color: GOLD },
                            }}
                          />
                        </TableCell>
                        {/* # */}
                        <TableCell sx={{ fontSize: 12, color: "#94a3b8", py: 1.5, px: 2, borderBottom: "1px solid #F3F4F6" }}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                        {/* Product */}
                        <TableCell sx={{ py: 1.5, px: 2, borderBottom: "1px solid #F3F4F6" }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                            <Box sx={{
                              width: 40, height: 40, borderRadius: 2, overflow: "hidden", flexShrink: 0,
                              border: "1px solid #f1f5f9", bgcolor: "#f8fafc",
                              display: "flex", alignItems: "center", justifyContent: "center",
                            }}>
                              <img
                                src={row.productImg ? `${LARAVEL_API_URL}/${row.productImg}` : placeholderImage}
                                alt=""
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              />
                            </Box>
                            <Link to={`/product-history/${row.id}`} style={{ textDecoration: "none", color: "inherit" }}>
                              <Typography sx={{
                                fontSize: 13, fontWeight: 600, color: "#111827",
                                wordBreak: "break-word", display: "-webkit-box",
                                WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden",
                                "&:hover": { color: GOLD }, transition: "color 0.15s", textTransform: "capitalize",
                              }}>
                                {row.productName?.charAt(0).toUpperCase() + row.productName?.slice(1)}
                              </Typography>
                            </Link>
                          </Box>
                        </TableCell>
                        {/* Barcode */}
                        <TableCell sx={{ py: 1.5, px: 2, borderBottom: "1px solid #F3F4F6" }}>
                          {(() => {
                            const codes = [
                              (row as any).productBarcode,
                              (row as any).productManualBarcode,
                            ]
                              .map((c) => (c == null ? "" : String(c).trim()))
                              .filter((c) => c !== "");
                            const unique = Array.from(new Set(codes));
                            if (unique.length === 0) {
                              return (
                                <Typography sx={{ fontSize: 12, color: "#94a3b8" }}>—</Typography>
                              );
                            }
                            return (
                              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                                {unique.map((code) => (
                                  <Typography
                                    key={code}
                                    sx={{
                                      fontSize: 11,
                                      fontFamily: "monospace",
                                      color: "#334155",
                                      bgcolor: "#F3F4F6",
                                      px: 1,
                                      py: 0.25,
                                      borderRadius: 1,
                                      display: "inline-block",
                                      width: "fit-content",
                                    }}
                                  >
                                    {code}
                                  </Typography>
                                ))}
                              </Box>
                            );
                          })()}
                        </TableCell>
                        {/* Category */}
                        <TableCell sx={{ fontSize: 12, color: "#334155", py: 1.5, px: 2, borderBottom: "1px solid #F3F4F6" }}>
                          {parentCategoryMap.get(row.productCategoryId) || coursingMap.get(row.productCategoryId) || "—"}
                        </TableCell>
                        {/* Sub Category */}
                        <TableCell sx={{ fontSize: 12, color: "#334155", py: 1.5, px: 2, borderBottom: "1px solid #F3F4F6", textTransform: "capitalize" }}>
                          {parentCategoryMap.has(row.productCategoryId) ? coursingMap.get(row.productCategoryId) || "—" : "—"}
                        </TableCell>
                        {/* Cost — click to edit */}
                        <TableCell
                          sx={{ fontSize: 12, fontWeight: 500, color: "#334155", py: 1.5, px: 2, borderBottom: "1px solid #F3F4F6", cursor: "pointer", "&:hover": { bgcolor: "#F9FAFB" } }}
                          onClick={() => handleDoubleClick(row.id, "productPrice", row.productPrice)}
                        >
                          {editingCell === `${row.id}-productPrice` ? (
                            <TextField size="small" type="number" value={editValue} onChange={(e) => setEditValue(e.target.value)}
                              onBlur={() => handleSaveInline(row, "productPrice")}
                              onKeyDown={(e) => { if (e.key === "Enter") handleSaveInline(row, "productPrice"); if (e.key === "Escape") setEditingCell(null); }}
                              autoFocus inputProps={{ step: "0.01" }}
                              sx={{ width: 90, "& .MuiOutlinedInput-root": { fontSize: 12, borderRadius: 1.5, "& fieldset": { borderColor: GOLD } } }} />
                          ) : (
                            <Typography fontSize={12} fontWeight={500} color="#374151" sx={{ "&:hover": { color: GOLD } }}>
                              {row.productPrice ? `$${Number(row.productPrice).toFixed(2)}` : "—"}
                            </Typography>
                          )}
                        </TableCell>
                        {/* Instore Price — click to edit */}
                        <TableCell
                          sx={{ fontSize: 12, fontWeight: 500, color: "#334155", py: 1.5, px: 2, borderBottom: "1px solid #F3F4F6", cursor: "pointer", "&:hover": { bgcolor: "#F9FAFB" } }}
                          onClick={() => handleDoubleClick(row.id, "salePrice", row.salePrice)}
                        >
                          {editingCell === `${row.id}-salePrice` ? (
                            <TextField size="small" type="number" value={editValue} onChange={(e) => setEditValue(e.target.value)}
                              onBlur={() => handleSaveInline(row, "salePrice")}
                              onKeyDown={(e) => { if (e.key === "Enter") handleSaveInline(row, "salePrice"); if (e.key === "Escape") setEditingCell(null); }}
                              autoFocus inputProps={{ step: "0.01" }}
                              sx={{ width: 90, "& .MuiOutlinedInput-root": { fontSize: 12, borderRadius: 1.5, "& fieldset": { borderColor: GOLD } } }} />
                          ) : (
                            <Typography fontSize={12} fontWeight={500} color="#059669" sx={{ "&:hover": { color: GOLD } }}>
                              {row.salePrice ? `$${Number(row.salePrice).toFixed(2)}` : "—"}
                            </Typography>
                          )}
                        </TableCell>
                        {/* Wholesale Price — click to edit */}
                        <TableCell
                          sx={{ fontSize: 12, fontWeight: 500, color: "#334155", py: 1.5, px: 2, borderBottom: "1px solid #F3F4F6", cursor: "pointer", "&:hover": { bgcolor: "#F9FAFB" } }}
                          onClick={() => handleDoubleClick(row.id, "wholesaleprice", row.wholesaleprice)}
                        >
                          {editingCell === `${row.id}-wholesaleprice` ? (
                            <TextField size="small" type="number" value={editValue} onChange={(e) => setEditValue(e.target.value)}
                              onBlur={() => handleSaveInline(row, "wholesaleprice")}
                              onKeyDown={(e) => { if (e.key === "Enter") handleSaveInline(row, "wholesaleprice"); if (e.key === "Escape") setEditingCell(null); }}
                              autoFocus inputProps={{ step: "0.01" }}
                              sx={{ width: 90, "& .MuiOutlinedInput-root": { fontSize: 12, borderRadius: 1.5, "& fieldset": { borderColor: GOLD } } }} />
                          ) : (
                            <Typography fontSize={12} fontWeight={500} color="#7C3AED" sx={{ "&:hover": { color: GOLD } }}>
                              {row.wholesaleprice ? `$${Number(row.wholesaleprice).toFixed(2)}` : "—"}
                            </Typography>
                          )}
                        </TableCell>
                        {/* Online */}
                        <TableCell sx={{ py: 1.5, px: 2, borderBottom: "1px solid #F3F4F6" }}>
                          <Chip
                            size="small"
                            icon={row.productViewOnline ? <CheckIcon sx={{ fontSize: 14 }} /> : <CloseIcon sx={{ fontSize: 14 }} />}
                            label={row.productViewOnline ? "Yes" : "No"}
                            sx={{
                              height: 24, fontSize: 11, fontWeight: 600,
                              bgcolor: row.productViewOnline ? "#f0fdf4" : "#fef2f2",
                              color: row.productViewOnline ? "#16a34a" : "#dc2626",
                              "& .MuiChip-icon": { color: "inherit" },
                            }}
                          />
                        </TableCell>
                        {/* Stock — click to edit */}
                        <TableCell
                          sx={{ py: 1.5, px: 2, borderBottom: "1px solid #F3F4F6", cursor: "pointer", "&:hover": { bgcolor: "#F9FAFB" } }}
                          onClick={() => handleDoubleClick(row.id, "stock", row.available_stock || 0)}
                        >
                          {editingCell === `${row.id}-stock` ? (
                            <TextField size="small" type="number" value={editValue} onChange={(e) => setEditValue(e.target.value)}
                              onBlur={() => handleSaveInline(row, "stock")}
                              onKeyDown={(e) => { if (e.key === "Enter") handleSaveInline(row, "stock"); if (e.key === "Escape") setEditingCell(null); }}
                              autoFocus inputProps={{ min: 0, step: 1 }}
                              sx={{ width: 80, "& .MuiOutlinedInput-root": { fontSize: 12, borderRadius: 1.5, "& fieldset": { borderColor: GOLD } } }} />
                          ) : (
                            <Chip size="small" label={row.available_stock || 0}
                              sx={{
                                height: 24, fontSize: 11, fontWeight: 700, minWidth: 36, cursor: "pointer",
                                bgcolor: (row.available_stock || 0) > 0 ? "#f0fdf4" : "#fef2f2",
                                color: (row.available_stock || 0) > 0 ? "#16a34a" : "#dc2626",
                                "&:hover": { opacity: 0.8 },
                              }} />
                          )}
                        </TableCell>
                        {/* Actions */}
                        <TableCell align="left" sx={{ py: 1.5, px: 2, borderBottom: "1px solid #F3F4F6", minWidth: 200 }}>
                          <ActionButtons
                            onView={() => navigate(`/product-history/${row.id}`)}
                            onEdit={() => navigate(`/product/edit/${row.id}`)}
                            onDelete={() => handleOpenDeletePopup(row)}
                          />
                        </TableCell>
                      </TableRow>
                      );
                    })
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", px: 2, py: 2, borderTop: "1px solid #f1f5f9" }}>
            <Pagination
              count={coursings.length}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
            />
          </Box>
        </Paper>

        {/* Edit now navigates to /product/edit/:id */}
        {productToDelete && (
          <DeletePopup
            open={openDeleteProduct}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(productToDelete.id.toString());
            }}
            title="Delete Product"
            content={`Are you sure you want to delete "${productToDelete.productName}"?`}
          />
        )}

        {/* ── Bulk Delete Confirm ── */}
        <Dialog
          open={bulkDeleteOpen}
          onClose={() => !bulkDeleting && setBulkDeleteOpen(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{ sx: { borderRadius: 3, border: `1px solid ${BORDER}`, boxShadow: "0 12px 36px rgba(15,23,42,0.16)" } }}
        >
          <DialogTitle sx={{ fontWeight: 800, fontSize: 16, color: NAVY, pb: 1 }}>
            Delete {selectedIds.size} selected product{selectedIds.size === 1 ? "" : "s"}?
          </DialogTitle>
          <DialogContent>
            <Typography fontSize={13} color={TEXT_SECONDARY}>
              This action cannot be undone.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2.25, gap: 1 }}>
            <Button
              onClick={() => setBulkDeleteOpen(false)}
              disabled={bulkDeleting}
              variant="outlined"
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, borderColor: BORDER, color: TEXT_SECONDARY }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleBulkDelete}
              disabled={bulkDeleting}
              variant="contained"
              disableElevation
              startIcon={bulkDeleting ? <CircularProgress size={14} sx={{ color: NAVY_DARK }} /> : <DeleteOutlineIcon sx={{ fontSize: 16 }} />}
              sx={{
                borderRadius: 2, textTransform: "none", fontWeight: 700,
                color: NAVY_DARK,
                background: `linear-gradient(135deg, ${GOLD} 0%, ${GOLD_SOFT} 100%)`,
                "&:hover": { background: `linear-gradient(135deg, #C8A030 0%, ${GOLD} 100%)` },
              }}
            >
              {bulkDeleting ? "Deleting..." : "Delete Products"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── Move Category Dialog ── */}
        <Dialog
          open={moveCategoryOpen}
          onClose={() => !moveCategoryBusy && setMoveCategoryOpen(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{ sx: { borderRadius: 3, border: `1px solid ${BORDER}`, boxShadow: "0 12px 36px rgba(15,23,42,0.16)" } }}
        >
          <DialogTitle sx={{ fontWeight: 800, fontSize: 16, color: NAVY, pb: 1 }}>
            Move {selectedIds.size} product{selectedIds.size === 1 ? "" : "s"} to category
          </DialogTitle>
          <DialogContent>
            <Typography fontSize={12} color={TEXT_SECONDARY} sx={{ mb: 1.5 }}>
              Select a destination category. All selected products will be reassigned.
            </Typography>
            <TextField
              select
              fullWidth
              size="small"
              value={moveCategoryTarget}
              onChange={(e) => setMoveCategoryTarget(e.target.value === "" ? "" : Number(e.target.value))}
              sx={selectSx}
            >
              <MenuItem value="" disabled sx={{ color: "#94a3b8", fontSize: 13 }}>Select category…</MenuItem>
              {categoryList && categoryList.map((category) => (
                <MenuItem key={category.id} value={category.id} sx={{ fontSize: 13 }}>{category.categoryName}</MenuItem>
              ))}
            </TextField>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2.25, gap: 1 }}>
            <Button
              onClick={() => { setMoveCategoryOpen(false); setMoveCategoryTarget(""); }}
              disabled={moveCategoryBusy}
              variant="outlined"
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, borderColor: BORDER, color: TEXT_SECONDARY }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleBulkMoveCategory}
              disabled={moveCategoryBusy || !moveCategoryTarget}
              variant="contained"
              disableElevation
              startIcon={moveCategoryBusy ? <CircularProgress size={14} sx={{ color: "#fff" }} /> : <DriveFileMoveIcon sx={{ fontSize: 16 }} />}
              sx={{
                borderRadius: 2, textTransform: "none", fontWeight: 700,
                bgcolor: NAVY, color: "#fff",
                "&:hover": { bgcolor: NAVY_DARK },
              }}
            >
              {moveCategoryBusy ? "Moving..." : "Move Products"}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default Index;
